"use client";

import { useEffect, useState } from "react";
import { EventLabels } from "@/app/constants/mix-panel-enums";
import { useMixPanel } from "@/app/context/mixPanelContext";
import { useAppContext } from "@thriwe-2-0/thriwe-ui-utils";
import parse from "html-react-parser";
import { useRouter } from "next/navigation";
import { useClientConfigProvider } from "@/app/config/client-config-provider";
import { useTranslation } from "react-i18next";
import { IoArrowBackOutline } from "react-icons/io5";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";

type Faq = {
  question: string;
  answer: string;
};

export default function FAQV2() {
  const router = useRouter();
  const { config } = useClientConfigProvider();
  const {
    instances: { apiRepository },
  } = useAppContext();
  const { trackEvent } = useMixPanel();
  const { t } = useTranslation();

  const [data, setData] = useState<Faq[] | null>(null);
  const [open, setOpen] = useState("0");
  const [loading, setLoading] = useState(true);

  // State to hold dynamic imported static FAQ component
  const [StaticFaqPage, setStaticFaqPage] = useState<React.FC | null>(null);

  useEffect(() => {
    trackEvent(EventLabels.SL_FAQ, { screen: "Support" });
    apiRepository
      ?.getStaticContent({
        faqs: true,
      })
      .then((v: any) => {
        trackEvent(EventLabels.SL_FAQ_Done, { screen: "Support" });
        const faqs = v?.data?.faqs ?? [];
        setData(faqs.length > 0 ? faqs : null);
        setLoading(false);
      })
      .catch(() => {
        setData(null);
        setLoading(false);
      });
  }, []);

useEffect(() => {
  if (config?.staticPages?.faqs?.path === "@/app/config/client-assets-config/eib/static-page-faq.tsx") {
    import("@/app/config/client-assets-config/eib/static-page/static-page-faq")
      .then(mod => {
        setStaticFaqPage(() => mod.default);
      })
      .catch(err => {
        setStaticFaqPage(null);
      });
  }
}, [config?.staticPages?.faqs?.path]);


  const toggle = (id: string) => {
    setOpen(open === id ? "" : id);
  };

  const addClassNames = (htmlString: string, isQuestion: boolean) => {
    return parse(htmlString, {
      replace: (domNode) => {
        if (domNode.type === "tag") {
          domNode.attribs = {
            ...domNode.attribs,
            class: `${domNode.attribs.class ?? ""} ${
              isQuestion ? "faq-question" : "faq-answer"
            }`.trim(),
          };
        }
        return domNode;
      },
    });
  };

  function handleBackArrowClick() {
    if (open !== "0") {
      setOpen("0");
    } else if (window.history.length > 1) {
      router.back();
    } else {
      window.close();
    }
  }

  return (
    <>
      <div className="section_faqs_v2">
        <div className="faqs_container_v2">
          <div className="navigation_container_v2">
            <div className="faqs_navigation_container_v2">
              <div className="back_navigation_v2" onClick={handleBackArrowClick}>
                <span className="back_navigation_icon_v2">
                  <IoArrowBackOutline size={19} />
                </span>
                <span className="back_navigation_text_v2">Frequently Asked Questions</span>
              </div>
            </div>
          </div>

          {data && data.length > 0 ? (
            <div className="faqs_text_container_v2">
              <Accordion open={open} toggle={toggle} style={{ background: "none" }}>
                {data.map((item, index) => (
                  <AccordionItem key={index} style={{ background: "none !important" }}>
                    <AccordionHeader targetId={`${index}`} style={{ background: "none !important" }}>
                      {addClassNames(item.question, true)}
                    </AccordionHeader>
                    <AccordionBody accordionId={`${index}`}>
                      {addClassNames(item.answer, false)}
                    </AccordionBody>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ) : StaticFaqPage ? (
            <StaticFaqPage />
          ) : (
            <div>No FAQs available.</div>
          )}
        </div>
      </div>
    </>
  );
}
